import React from 'react';
import { useSelector } from 'react-redux';
// import LiveChatSupport from '../../common/CustomComponents/LiveChatSupport';
import MoreSupport from '../../common/CustomComponents/MoreSupport';
import RowContainer from '../../common/CustomComponents/RowContainer';
import { usePageTitle } from '../../common/hooks/usePageTitle';

const MemberSupport = () => {
  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
  const memberSupportLayout = tenantLayouts && tenantLayouts.moreSupportPage;
  const tenantInfo = useSelector(state => state?.tenant?.tenantInfo);

  usePageTitle(memberSupportLayout && memberSupportLayout.pageTitle);
  
  switch (tenantInfo['tenantHandle']) {
    case 'dchp':
     return <MoreSupport />;
  
      default :
       return (
    memberSupportLayout && (
      <div
        className={memberSupportLayout.className}
        id={memberSupportLayout.id}
      >
        {memberSupportLayout.sections.map((item, index) => {
          return <RowContainer key={index} {...item} />;
        })}
      </div>
    )
  );
      }
};

export default MemberSupport;